webpackJsonp([264],{

/***/ 1120:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentOutboundCallDetail_vue__ = __webpack_require__(2732);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7936385d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentOutboundCallDetail_vue__ = __webpack_require__(4272);
function injectStyle (ssrContext) {
  __webpack_require__(4266)
  __webpack_require__(4268)
  this["$style"] = __webpack_require__(4270)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7936385d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IntelligentOutboundCallDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7936385d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IntelligentOutboundCallDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2732:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  mixins: [],
  data: function data() {
    return {
      form: {
        title: '',
        customer_id: '',
        customer_name: '',
        project_id: '',
        project_name: '',
        robot_tpl: '',
        retry_times: '',
        retry_duration: '',
        operation_logs: [],

        total_cnt: '',
        pending_cnt: '',
        noanswered_cnt: '',
        answered_cnt: '',
        closed_cnt: '',
        failed_cnt: ''
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {
    this.id = this.$route.params.id;
    this.id > 0 && this.setDetailData(this.id);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    setDetailData: function setDetailData(id) {
      var _this = this;

      request.page('getIntelligentOutboundCallDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        filter.setLoop(_this.form, data);
        _this.form.customer_id = _this.form.customer_id + '';
        _this.form.project_id = _this.form.project_id + '';
        _this.getProjectInfoRemote().then(function (_ref2) {
          var data = _ref2.data;

          _this.form.customer_name = data.name + '/' + data.number;
        });
        _this.getCustomerInfoRemote().then(function (_ref3) {
          var data = _ref3.data;

          _this.form.project_name = data.name + '/' + data.number;
        });
        _this.form.retry_duration = Number(_this.form.retry_duration) / 60;
      });
    },
    getProjectInfoRemote: function getProjectInfoRemote() {
      return request.common('getProjectDetail', { id: this.form.project_id });
    },
    getCustomerInfoRemote: function getCustomerInfoRemote() {
      return request.common('getCustomerDetail', { id: this.form.customer_id });
    }
  })
});

/***/ }),

/***/ 4266:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("d8f7c1c8", content, true, {});

/***/ }),

/***/ 4267:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"IntelligentOutboundCallDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4268:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4269);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3d70bfac", content, true, {});

/***/ }),

/***/ 4269:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"IntelligentOutboundCallDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4270:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(4271);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2fa4d212", content, true, {});

/***/ }),

/***/ 4271:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"IntelligentOutboundCallDetail.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 4272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("智能外呼列表")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v(_vm._s(_vm.$route.meta.title))]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"size":"medium","label-width":"140px"}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium",staticStyle:{"width":"100%"}},[_c('el-form-item',{attrs:{"label":"任务描述","prop":"title"}},[_c('span',[_vm._v(_vm._s(_vm.form.title))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户","prop":"customer_id"}},[_c('span',[_vm._v(_vm._s(_vm.form.customer_name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"项目","prop":"project_id"}},[_c('span',[_vm._v(_vm._s(_vm.form.project_name))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"外呼模板","prop":"robot_tpl"}},[_c('span',[_vm._v(_vm._s(_vm.form.robot_tpl))])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"未拨打重试次数","prop":"retry_times"}},[_c('span',[_vm._v(_vm._s(_vm.form.retry_times)+"次")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"未拨打重试间隔","prop":"retry_duration"}},[_c('span',[_vm._v(_vm._s(_vm.form.retry_duration)+"分钟")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"操作日志","prop":"operation_logs"}},[_vm._l((_vm.form.operation_logs),function(log,index){return _c('div',{key:index},[_c('span',[_vm._v(_vm._s(log.created_at))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(log.adminname))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(log.msg))])])}),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":[_vm.form],"stripe":"","highlight-current-row":"","border":""}},[_c('el-table-column',{attrs:{"prop":"total_cnt","label":"总数","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"pending_cnt","label":"待呼叫数","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"closed_cnt","label":"不呼叫数","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"answered_cnt","label":"已接通数","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"noanswered_cnt","label":"未接通数","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"failed_cnt","label":"失败数","min-width":"120"}})],1)],2),_vm._v(" "),_c('el-form-item',{attrs:{"label":""}},[_c('router-link',{attrs:{"to":("/intelligent-outbound-call/detail-table/" + (this.id))}},[_c('el-button',{attrs:{"size":"mini","type":"text"}},[_vm._v("外呼明细")])],1)],1)],1)])]),_vm._v(" "),_c('router-link',{attrs:{"to":"/intelligent-outbound-call/table"}},[_c('el-button',[_vm._v("返回")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/intelligent-outbound-call-detail.19beb1141b34c7e5d245.js